<bos-root>
    <router-outlet name="popup"></router-outlet>
    <router-outlet *ngIf="show"></router-outlet>
</bos-root>
